import React from 'react'
import PropTypes from 'prop-types';
import './index.scss'

const LineTitle = (props) => {
  const {
    title,
    secondTitle
  } = props
  return (
    <div className='lineTitleBox'>
      <div className='firstTitle'>
        {
          secondTitle ? (
            <div className={secondTitle ? 'secondLineText' : 'lineTitleText'}>
              {secondTitle + ' | ' + title}
            </div>
          ) : (
            <div className="lineTitleText">
              <div className="titleLine">
                {title}
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}
LineTitle.defaultProps = {
  secondTitle: false
}
LineTitle.propTypes = {
  title: PropTypes.string,
  secondTitle: PropTypes.string,
}
export default LineTitle